<div class="modal-header spm-header">
  <div class="spm-header-left">
    <h4 class="modal-title spm-title">{{insurerDisplayName}} - {{actionLabel}}</h4>
    <span class="spm-status-badge" [ngClass]="statusBadgeClass">
      <span class="spm-status-dot"></span>{{statusLabel}}
    </span>
  </div>
  @if (isTerminal) {
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  }
</div>

<div class="modal-body spm-body">
  <div class="spm-steps">
    <div class="spm-steps-head">
      <span>{{totalSteps ? ('Step ' + completedStepCount + ' of ' + totalSteps) : ('Steps (' + completedStepCount + ')')}}</span>
      <span>Status</span>
    </div>
    <div class="spm-steps-list">
      @for (entry of stepLog; track entry.stepId; let i = $index; let last = $last) {
        <div class="spm-step-row-wrap">
          <div
            class="spm-step-row"
            [class.is-current]="last && status === 'running'"
            [class.is-expandable]="hasStepDetail(entry.stepId)"
            (click)="hasStepDetail(entry.stepId) && toggleExpand(entry.stepId)"
          >
            <span class="spm-step-name" [title]="'Reference: ' + entry.stepId">
              @if (hasStepDetail(entry.stepId)) {
                <span class="spm-step-caret" [class.expanded]="isExpanded(entry.stepId)">&#9656;</span>
              }
              @if (entry.isSummary) {
                {{entry.stepLabel}}
              } @else {
                Step {{i}}: {{entry.stepLabel}}
              }
            </span>
            <span class="spm-step-status" [ngClass]="rowStatusClass(last)">
              <span class="spm-status-dot"></span>{{rowStatusLabel(last)}}
            </span>
          </div>
          @if (isExpanded(entry.stepId)) {
            <div class="spm-step-detail">
              @for (field of stepDetailFields(entry.stepId); track field.label) {
                <div class="spm-detail-row"><span class="spm-detail-key">{{field.label}}</span><span class="spm-detail-value">{{field.value}}</span></div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>

  @if (status === 'running' || status === 'paused') {
    <p class="spm-hint">
      @if (status === 'paused') {
        Paused before step {{completedStepCount}}{{totalSteps ? ' of ' + totalSteps : ''}}: {{currentStepLabel || 'the next step'}}. Click Continue to resume, or Next Step to run just one step at a time.
      } @else {
        Currently on step {{completedStepCount}}{{totalSteps ? ' of ' + totalSteps : ''}}: {{currentStepLabel || 'starting...'}} - this can take a few seconds per step.
      }
    </p>
  }

  @if (isError) {
    <div class="spm-error">
      <strong [title]="'Reference: ' + (error?.stepId ?? '')">Stopped at: {{error?.stepLabel}}</strong>
      <div class="spm-error-message">{{error?.message}}</div>
      <p class="spm-error-tip">
        The {{insurerDisplayName}} browser window is still open - you can fix the issue directly
        in it (dismiss a dialog, correct a field, solve a captcha, etc.), then click Continue to
        retry this step.
      </p>
    </div>
  }

  @if (status === 'done') {
    <div class="alert alert-success spm-alert mt-2 mb-0">Quotation retrieved successfully.</div>
    @if (resultWarning) {
      <div class="spm-warning">
        <strong>Failed Reason</strong>
        <div class="spm-warning-message">{{resultWarning}}</div>
      </div>
    }
    @if (resultEntries().length) {
      <div class="spm-result">
        <div class="spm-result-title">Extracted from portal</div>
        @for (entry of resultEntries(); track entry.label) {
          @if (entry.nested) {
            <div class="spm-detail-row spm-detail-row-group"><span class="spm-detail-key">{{entry.label}}</span></div>
            @for (sub of entry.nested; track sub.label) {
              <div class="spm-detail-row spm-detail-row-nested"><span class="spm-detail-key">{{sub.label}}</span><span class="spm-detail-value">{{sub.value}}</span></div>
            }
          } @else {
            <div class="spm-detail-row"><span class="spm-detail-key">{{entry.label}}</span><span class="spm-detail-value">{{entry.value}}</span></div>
          }
        }
      </div>
    }
  }

  @if (status === 'aborted' || status === 'failed') {
    <div class="alert alert-danger spm-alert mt-2 mb-0">
      {{status === 'failed' ? 'Automation service error: ' + (error?.message ?? '') : 'Aborted by operator.'}}
    </div>
  }
</div>

<div class="modal-footer spm-footer">
  @if (canPause) {
    <button type="button" class="btn btn-outline-secondary" [disabled]="busy" (click)="onPause()">Pause</button>
  }
  @if (canContinue) {
    <button type="button" class="btn btn-outline-primary" [disabled]="busy" (click)="onContinue(true)" title="Run just the next step, then pause again">Next Step</button>
    <button type="button" class="btn btn-primary" [disabled]="busy" (click)="onContinue()">Continue</button>
  }
  @if (!isTerminal) {
    <button type="button" class="btn btn-outline-danger" [disabled]="busy" (click)="onAbort()">Abort</button>
  }
  @if (isTerminal) {
    <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
  }
</div>
